var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import WmRequest from '../../common/request';
import Config from '../../common/config';
var SUGGEST_LIMIT = 5;
var DEBOUNCE_MS = 300;
var MAX_TEXT_LEN = 40;
/** 超过 maxLen 字符时截断并追加省略号 */
function truncateText(text, maxLen) {
    if (maxLen === void 0) { maxLen = MAX_TEXT_LEN; }
    var chars = Array.from(text);
    if (chars.length <= maxLen) {
        return text;
    }
    return chars.slice(0, maxLen).join('') + '...';
}
/**
 * 帮助中心 / 搜索结果页搜索框联想词
 * 调用 /searchSuggestApi，面板宽度与搜索框一致，位于搜索框下方 2px
 */
var HelpSearchSuggest = /** @class */ (function () {
    function HelpSearchSuggest(searchBox, onSelect) {
        this.debounceTimer = 0;
        this.requestSeq = 0;
        this.activeIndex = -1;
        this.suggestions = [];
        this.input = searchBox.querySelector('.search-input');
        this.suggestEl = searchBox.querySelector('.daetool-search-suggest');
        this.listEl = this.suggestEl.querySelector('.daetool-search-suggest__list');
        this.onSelect = onSelect;
        this.wmRequest = new WmRequest();
        this.bindEvents();
    }
    /** Enter 键：有选中项时填入并搜索，返回 true 表示已处理 */
    HelpSearchSuggest.prototype.handleEnter = function () {
        if (!this.isVisible() || this.activeIndex < 0 || !this.suggestions[this.activeIndex]) {
            return false;
        }
        this.selectKeyword(this.suggestions[this.activeIndex]);
        return true;
    };
    HelpSearchSuggest.prototype.isVisible = function () {
        return !this.suggestEl.hidden;
    };
    HelpSearchSuggest.prototype.bindEvents = function () {
        var _this = this;
        this.input.addEventListener('input', function () {
            _this.scheduleFetch();
        });
        this.input.addEventListener('focus', function () {
            var keyword = _this.input.value.trim();
            if (keyword) {
                _this.scheduleFetch();
            }
        });
        this.input.addEventListener('blur', function () {
            window.setTimeout(function () {
                _this.hide();
            }, 150);
        });
        this.input.addEventListener('keydown', function (event) {
            if (!_this.isVisible() || _this.suggestions.length === 0) {
                return;
            }
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                _this.moveActive(1);
            }
            else if (event.key === 'ArrowUp') {
                event.preventDefault();
                _this.moveActive(-1);
            }
            else if (event.key === 'Escape') {
                _this.hide();
            }
        });
        this.listEl.addEventListener('mousedown', function (event) {
            // 防止点击联想项时 input 先 blur 导致面板消失
            event.preventDefault();
        });
        this.listEl.addEventListener('click', function (event) {
            var item = event.target.closest('.daetool-search-suggest__item');
            if (!item) {
                return;
            }
            var index = Number(item.dataset.index);
            var keyword = _this.suggestions[index];
            if (keyword) {
                _this.selectKeyword(keyword);
            }
        });
        this.listEl.addEventListener('mouseover', function (event) {
            var item = event.target.closest('.daetool-search-suggest__item');
            if (!item) {
                return;
            }
            _this.setActiveIndex(Number(item.dataset.index));
        });
    };
    HelpSearchSuggest.prototype.scheduleFetch = function () {
        var _this = this;
        window.clearTimeout(this.debounceTimer);
        this.debounceTimer = window.setTimeout(function () {
            _this.fetchSuggestions();
        }, DEBOUNCE_MS);
    };
    HelpSearchSuggest.prototype.fetchSuggestions = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var keyword, seq, res, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        keyword = this.input.value.trim();
                        if (!keyword) {
                            this.hide();
                            return [2 /*return*/];
                        }
                        seq = ++this.requestSeq;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.wmRequest.ajax({
                                url: Config.WM_SEARCH_SUGGEST,
                                type: 'GET',
                                data: {
                                    keywords: keyword,
                                    limit: SUGGEST_LIMIT,
                                },
                            })];
                    case 2:
                        res = (_c.sent());
                        if (seq !== this.requestSeq) {
                            return [2 /*return*/];
                        }
                        if (res.code !== 200 || !Array.isArray((_a = res.data) === null || _a === void 0 ? void 0 : _a.list) || res.data.list.length === 0) {
                            this.hide();
                            return [2 /*return*/];
                        }
                        this.suggestions = res.data.list;
                        this.renderList();
                        this.show();
                        return [3 /*break*/, 4];
                    case 3:
                        _b = _c.sent();
                        if (seq === this.requestSeq) {
                            this.hide();
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    HelpSearchSuggest.prototype.renderList = function () {
        this.listEl.innerHTML = this.suggestions
            .map(function (word, index) {
            return "<li class=\"daetool-search-suggest__item".concat(index === 0 ? ' is-active' : '', "\" role=\"option\" data-index=\"").concat(index, "\" title=\"").concat(word.replace(/"/g, '&quot;'), "\">").concat(truncateText(word), "</li>");
        })
            .join('');
        this.activeIndex = 0;
    };
    HelpSearchSuggest.prototype.show = function () {
        this.suggestEl.hidden = false;
        this.suggestEl.setAttribute('aria-hidden', 'false');
    };
    HelpSearchSuggest.prototype.hide = function () {
        this.suggestEl.hidden = true;
        this.suggestEl.setAttribute('aria-hidden', 'true');
        this.suggestions = [];
        this.activeIndex = -1;
        this.listEl.innerHTML = '';
    };
    HelpSearchSuggest.prototype.moveActive = function (delta) {
        if (this.suggestions.length === 0) {
            return;
        }
        var next = (this.activeIndex + delta + this.suggestions.length) % this.suggestions.length;
        this.setActiveIndex(next);
    };
    HelpSearchSuggest.prototype.setActiveIndex = function (index) {
        if (index < 0 || index >= this.suggestions.length) {
            return;
        }
        this.activeIndex = index;
        var items = this.listEl.querySelectorAll('.daetool-search-suggest__item');
        items.forEach(function (item, i) {
            item.classList.toggle('is-active', i === index);
        });
    };
    HelpSearchSuggest.prototype.selectKeyword = function (keyword) {
        this.input.value = keyword;
        this.hide();
        this.onSelect(keyword);
    };
    return HelpSearchSuggest;
}());
export default HelpSearchSuggest;
